function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import pluck from 'ramda/src/pluck';
import { stateGo } from 'redux-ui-router';
import { LanguageHeaderSelector, LastRouteSelector } from 'invision-core/src/components/session/session.selectors';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { RouteParams, RouteCurrentStateSelector } from 'invision-core/src/components/router/router.selectors';
import customerLocaleKeys from '../../../../locales/keys';
import { SERVICES_USAGE_STATE_NAME } from '../../servicesAndUsage/services.and.usage.config';
import { RESUME_ORDER_INSUFFICIENT_ACCESS_WARNING_CODE } from '../../../../customercare.constants';
import { DASHBOARD_ROUTE } from '../../../../reducers/constants/dashboard.constants';
import { getOfferingMetadata, resetTransfer, retrieveCustomer, retrieveTransferableOfferings, retrieveTransferOfferingContext, selectOfferingForTransfer, setOfferingsMetadata, unselectOfferingForTransfer, updateShoppingCart, validateSubscriberForServiceTransfer } from '../../../../reducers/actions/transfer.wizard.actions';
import { CurrentCustomerNameSelector, CurrentCustomerSelector } from '../../../../reducers/selectors/customer.selectors';
import { IsFetchingTransferableOfferingsSelector, IsValidatingSubscriberForTransferSelector, OfferingInstancesSelectedForTransferSelector, SelectedDestinationCustomerSelector, TransferableOfferingsSelector, TransferableOfferingsViewModelSelector } from '../../../../reducers/selectors/transfer.wizard.selectors';
import { setTransferFromName } from '../../../../reducers/actions/add.offer.wizard.actions';
import { STATE_OR_NAME as ADD_OFFER_STATE } from '../../../../reducers/constants/add.offer.wizard.constants';
var TransferWizardController = /*#__PURE__*/function () {
  function TransferWizardController($ngRedux, $state, $timeout, uiNotificationService) {
    _classCallCheck(this, TransferWizardController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $state: $state,
      $timeout: $timeout,
      closeCustomerSearchDialogPopup: this.closeCustomerSearchDialogPopup.bind(this),
      customerLocaleKeys: customerLocaleKeys,
      isOffersLoading: false,
      isWizardLoading: false,
      onCustomerSelected: this.onCustomerSelected.bind(this),
      openCustomerSearchDialogPopup: this.openCustomerSearchDialogPopup.bind(this),
      resumeOrderWarning: RESUME_ORDER_INSUFFICIENT_ACCESS_WARNING_CODE,
      selectOffering: this.selectOffering.bind(this),
      servicesAndUsageUrl: SERVICES_USAGE_STATE_NAME,
      showCustomerSearchDialog: false,
      startTransferClicked: false,
      uiNotificationService: uiNotificationService,
      unselectOffering: this.unselectOffering.bind(this)
    });
  }
  return _createClass(TransferWizardController, [{
    key: "_connectRedux",
    value: function _connectRedux() {
      var _this = this;
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        getOfferingMetadata: getOfferingMetadata,
        resetTransfer: resetTransfer,
        retrieveCustomer: retrieveCustomer,
        retrieveTransferableOfferings: retrieveTransferableOfferings,
        retrieveTransferOfferingContext: retrieveTransferOfferingContext,
        selectOfferingForTransfer: selectOfferingForTransfer,
        setOfferingsMetadata: setOfferingsMetadata,
        setTransferFromName: setTransferFromName,
        stateGo: stateGo,
        unselectOfferingForTransfer: unselectOfferingForTransfer,
        updateShoppingCart: updateShoppingCart,
        validateSubscriberForServiceTransfer: validateSubscriberForServiceTransfer
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomer: CurrentCustomerSelector(store),
          currentCustomerName: CurrentCustomerNameSelector(store),
          currentUserLanguage: LanguageHeaderSelector(store),
          isFetchingTransferableOfferings: IsFetchingTransferableOfferingsSelector(store),
          isRegularExpressionCodeTableLoaded: MetadataCodeLoadedSelector(CODES.RegularExpression, store),
          isServiceAttributeCodeTableLoaded: MetadataCodeLoadedSelector(CODES.ServiceAttribute, store),
          isValidatingSubscriberForTransfer: IsValidatingSubscriberForTransferSelector(store),
          lastRoute: LastRouteSelector(store),
          offeringInstancesSelectedForTransfer: OfferingInstancesSelectedForTransferSelector(store),
          routeParams: RouteParams(store),
          routeState: RouteCurrentStateSelector(store),
          selectedDestinationCustomer: SelectedDestinationCustomerSelector(store),
          transferableOfferings: TransferableOfferingsSelector(store),
          transferableOfferingsViewModel: TransferableOfferingsViewModelSelector(store)
        };
      };
      this._disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      this._connectRedux();
      this.optionalParams = {
        customerId: this.state.currentCustomer.Id
      };
      if (!this.state.isRegularExpressionCodeTableLoaded) {
        this.actions.fetchCodeTypes(CODES.RegularExpression);
      }
      if (!this.state.isServiceAttributeCodeTableLoaded) {
        this.actions.fetchCodeTypes(CODES.ServiceAttribute);
      }
      this.actions.retrieveTransferableOfferings(this.state.currentCustomer.Id).then(function (response) {
        if (response.Offerings && response.Offerings.length) {
          _this2.isOffersLoading = true;
          var offeringIds = Array.from(new Set(pluck('OrderedOfferingId', response.Offerings)));
          Promise.all(offeringIds.map(function (id) {
            return _this2.actions.getOfferingMetadata(id, _this2.state.currentCustomer.Language);
          })).then(function (response) {
            _this2.actions.setOfferingsMetadata(response);
          }).catch(function (error) {
            _this2.uiNotificationService.transientError(error.translatedMessage);
          }).finally(function () {
            _this2.isOffersLoading = false;
          });
        }
      }).catch(function (error) {
        _this2.uiNotificationService.transientError(error.translatedMessage);
      });
      this.customerSearchDialogPopupConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this2.customerSearchDialogPopupApi = api;
        }
      };
      this.insufficientPermissionsWarningPopup = {
        onRegisterApi: function onRegisterApi(event) {
          _this2.insufficientPermissionsWarningPopup = event.api;
        }
      };
      this.openInsufficientPermissionsWarningPopup = function () {
        _this2.insufficientPermissionsWarningPopup.open();
      };
      this.closeInsufficientPermissionsWarningPopup = function () {
        _this2.insufficientPermissionsWarningPopup.close();
        _this2.goBackToDashboard();
      };
      this.goBackToDashboard = function () {
        var route = _this2.servicesAndUsageUrl;
        var params = _this2.state.lastRoute.params || {};
        _this2.$state.go(route, params);
      };
    }
  }, {
    key: "openCustomerSearchDialogPopup",
    value: function openCustomerSearchDialogPopup() {
      var _this3 = this;
      this.showCustomerSearchDialog = true;
      this.$timeout(function () {
        _this3.customerSearchDialogPopupApi.open();
      });
    }
  }, {
    key: "closeCustomerSearchDialogPopup",
    value: function closeCustomerSearchDialogPopup() {
      this.showCustomerSearchDialog = false;
      this.customerSearchDialogPopupApi.close();
    }
  }, {
    key: "onCustomerSelected",
    value: function onCustomerSelected(selectedCustomerId) {
      var _this4 = this;
      this.actions.validateSubscriberForServiceTransfer(selectedCustomerId, this.state.currentCustomer.Id).then(function () {
        _this4.actions.retrieveCustomer(selectedCustomerId, _this4.state.currentUserLanguage).catch(function (error) {
          _this4.uiNotificationService.transientError(error.translatedMessage);
        });
        _this4.closeCustomerSearchDialogPopup();
      }).catch(function (error) {
        _this4.uiNotificationService.transientError(error.translatedMessage);
      });
    }
  }, {
    key: "startTransfer",
    value: function startTransfer() {
      var _this5 = this;
      this.startTransferClicked = true;
      if (this.state.offeringInstancesSelectedForTransfer.length && this.state.selectedDestinationCustomer.Id) {
        this.isWizardLoading = true;
        var transferPayload = this.state.offeringInstancesSelectedForTransfer.map(function (offeringInstanceId) {
          return {
            OfferingId: _this5.state.transferableOfferings.find(function (offering) {
              return offeringInstanceId === offering.OfferingInstanceId;
            }).OrderedOfferingId,
            OfferingInstanceId: offeringInstanceId
          };
        });
        this.actions.retrieveTransferOfferingContext(this.state.currentCustomer.Id, transferPayload).then(function (response) {
          var shoppingCart = Object.assign({}, response.ShoppingCart, {
            TransferFromSubscriberId: _this5.state.currentCustomer.Id
          });
          if (response.Warnings && !!response.Warnings.find(function (warning) {
            return warning.Code === _this5.resumeOrderWarning;
          })) {
            _this5.openInsufficientPermissionsWarningPopup();
            return Promise.reject();
          }
          return _this5.actions.updateShoppingCart(_this5.state.selectedDestinationCustomer.Id, shoppingCart);
        }).then(function () {
          _this5.actions.setTransferFromName(_this5.state.currentCustomerName);
          _this5.actions.stateGo(ADD_OFFER_STATE, {
            customerId: _this5.state.selectedDestinationCustomer.Id
          });
        }).catch(function (error) {
          // only handling isWizardLoading false on catch due to the success taking you to another url
          _this5.isWizardLoading = false;
          _this5.uiNotificationService.transientError(error.translatedMessage);
        });
      } else if (this.state.offeringInstancesSelectedForTransfer.length && !this.state.selectedDestinationCustomer.Id) {
        this.openCustomerSearchDialogPopup();
      }
    }
  }, {
    key: "selectOffering",
    value: function selectOffering(offeringInstanceId) {
      this.actions.selectOfferingForTransfer(offeringInstanceId);
      if (this.showNoServicesSelectedError) {
        this.showNoServicesSelectedError = false;
      }
    }
  }, {
    key: "unselectOffering",
    value: function unselectOffering(offeringInstanceId) {
      this.actions.unselectOfferingForTransfer(offeringInstanceId);
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.actions.resetTransfer();
      this._disconnectRedux();
    }
  }]);
}();
export default {
  controller: TransferWizardController,
  template: require('./transfer.wizard.html')
};